import { PhotoIcon } from '@heroicons/react/24/solid';

const SkeletalRefLoader = () => (
  <div
    className="animate-pulse space-y-8 rtl:space-x-reverse md:flex md:items-center md:space-y-0 md:space-x-8"
    role="status"
  >
    <div className="flex h-48 w-full items-center justify-center rounded bg-gray-300 sm:w-96">
      <PhotoIcon className="h-10 w-10 text-gray-200 " />
    </div>
    <div className="w-full">
      <div className="mb-4 h-2.5 w-48 rounded-full bg-gray-200"></div>
      <div className="mb-2.5 h-2 max-w-[480px] rounded-full bg-gray-200"></div>
      <div className="mb-2.5 h-2 rounded-full bg-gray-200 "></div>
      <div className="mb-2.5 h-2 max-w-[440px] rounded-full bg-gray-200"></div>
      <div className="mb-2.5 h-2 max-w-[460px] rounded-full bg-gray-200"></div>
      <div className="h-2 max-w-[360px] rounded-full bg-gray-200"></div>
    </div>
  </div>
);

export const SkeletalRefLoaderMini = () => (
  <div
    className="flex h-full w-full animate-pulse items-center justify-center rounded bg-gray-300"
    role="status"
  >
    <PhotoIcon className="h-1/4 min-h-[2rem] w-1/4 min-w-[2rem] text-gray-200" />
  </div>
);

export const SkeletalRefLoaderText = () => (
  <div className="min-w-16 h-4 w-16 animate-pulse rounded-full bg-gray-200" />
);

export default SkeletalRefLoader;
